import { Container, useColorModeValue } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export default function TransactionLayout() {
  const bg = useColorModeValue('white', 'gray.800')
  return (
    <Container maxW='full' bg={bg} py='1em' px='1.5em'>
      <Outlet />
    </Container>
  );
}

